// src/translations/index.ts

import ar from './ar';
import en from './en';

export type Language = 'ar' | 'en';
export type TranslationKey = string;

const translations: Record<Language, Record<string, string>> = { ar, en };

export { ar, en };
export default translations;
